import { Activity, activityAdapter } from '@ott/activity-card';

export type PrepareActivitiesOptions = {
  shouldPrioritiseDiscounted: boolean;
  shouldPrioritiseLiked: boolean;
};

const toNumber = (value?: boolean | number) => Number(value || 0);

const createSorter = ({
  shouldPrioritiseDiscounted,
  shouldPrioritiseLiked,
}: PrepareActivitiesOptions) => {
  return (a: Activity, b: Activity) => {
    const likeSort = shouldPrioritiseLiked ? toNumber(b.favorite) - toNumber(a.favorite) : 0;
    const discountSort = shouldPrioritiseDiscounted
      ? toNumber(b.discount) - toNumber(a.discount)
      : 0;

    return likeSort || discountSort;
  };
};

export const prepareActivities = (
  rawActivities: any[],
  { shouldPrioritiseDiscounted, shouldPrioritiseLiked }: PrepareActivitiesOptions
): Activity[] => {
  const activities = rawActivities.map(activityAdapter);

  const highlightedActivities: Activity[] = [];
  const restActivities: Activity[] = [];

  activities.forEach((activity) => {
    const ratingValue = activity.rating?.value || 0;

    if (
      (shouldPrioritiseDiscounted && activity.discount && ratingValue > 7) ||
      (shouldPrioritiseLiked && activity.favorite)
    ) {
      highlightedActivities.push(activity);
    } else {
      restActivities.push(activity);
    }
  });

  return [
    ...highlightedActivities.sort(
      createSorter({
        shouldPrioritiseDiscounted,
        shouldPrioritiseLiked,
      })
    ),
    ...restActivities,
  ];
};
